import { Separator } from "@/components/ui/separator";
import samranLogo from "@/assets/samran-logo-light.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground border-t border-white/10">
      <div className="container mx-auto px-6 py-12 pb-28 md:pb-12">

        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Logo */}
          <a href="/">
            <img 
              src={samranLogo} 
              alt="Gurbir Samran Farm & Land Real Estate" 
              className="h-14 w-auto"
              loading="lazy"
            />
          </a>

          {/* Links */}
          <div className="flex flex-wrap gap-6 justify-center text-sm">
            <a href="/about" className="text-white/70 hover:text-primary transition-colors">About Us</a>
            <a href="/buy-a-farm" className="text-white/70 hover:text-primary transition-colors">Buy A Farm</a>
            <a href="/sell-a-farm" className="text-white/70 hover:text-primary transition-colors">Sell A Farm</a>
            <a href="/farm-management" className="text-white/70 hover:text-primary transition-colors">Farm Management</a>
            <a href="/guides/buying-a-farm-central-valley" className="text-white/70 hover:text-primary transition-colors">Buying a Farm Guide</a>
            <a href="/guides/almond-vs-pistachio-roi" className="text-white/70 hover:text-primary transition-colors">Almonds vs Pistachios</a>
            <a href="/guides/buying-a-citrus-orchard" className="text-white/70 hover:text-primary transition-colors">Citrus Orchard Guide</a>
            <a href="/farms-for-sale/merced-county" className="text-white/70 hover:text-primary transition-colors">Merced County</a>
            <a href="/farms-for-sale/madera-county" className="text-white/70 hover:text-primary transition-colors">Madera County</a>
            <a href="/farms-for-sale/fresno-county" className="text-white/70 hover:text-primary transition-colors">Fresno County</a>
          </div>


          {/* Contact */}
          <div className="text-center md:text-right">
            <a href="tel:+15598719051" className="text-white/70 hover:text-primary transition-colors block text-sm">(559) 871-9051</a>
            <a href="mailto:gurbirsamran@gmail.com" className="text-white/70 hover:text-primary transition-colors block text-sm mt-1">gurbirsamran@gmail.com</a>
          </div>
        </div>

        <Separator className="my-8 bg-white/10" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-xs">
            © {currentYear} Gurbir Samran Real Estate. All rights reserved.
          </p>
          <div className="flex gap-6 text-white/40 text-xs">
            <a href="/privacy-policy" className="hover:text-white/70 transition-colors">Privacy Policy</a>
            <a href="/terms-of-service" className="hover:text-white/70 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
